


import * as Actions from '../actions';

const initialState = {
    isLoading: true,
    errMsg: null,
    data: []
    };


// get active categories
export const createQuotationReducer = function(state = initialState, action) {
switch (action.type) {
case Actions.CREATE_QUOTATION_CUTOMER:
return { ...state, isLoading: false, errMsg: null, data: action.payload };
case Actions.CREATE_QUOTATION_CUTOMER_LOADING:
return { ...state, isLoading: true, errMsg: null, data: [] };
case Actions.CREATE_QUOTATION_CUTOMER_LOADING_FAILED:
return { ...state, isLoading: false, errMsg: action.payload, data: [] };
default:
return state;
}
};
